import { Button, styled } from '@mui/material';

interface StyButtonAdditionalProps {
    buttonStyle: 'success' | 'error' | 'warning' | 'primary';
    selected: boolean;
}

export const StyButton = styled(Button, {
    name: 'StyButton',
    shouldForwardProp: (prop) => prop !== 'buttonStyle' && prop !== 'selected',
})<StyButtonAdditionalProps>(({ theme, selected, buttonStyle }) => {
    const { palette } = theme;
    const color = palette[buttonStyle];
    const baseStyle = {
        height: theme.spacing(7),
    };
    if (selected) {
        return {
            ...baseStyle,
            borderColor: color.main,
            backgroundColor: color.main,
            color: palette.common.white,
            ':hover': {
                borderColor: color.main,
                backgroundColor: color.main,
            },
            '& .MuiSvgIcon-root': {
                color: palette.common.white,
            },
        };
    }
    return {
        ...baseStyle,
        borderColor: palette.grey[500],
        color: palette.text.primary,
        ':hover': {
            borderColor: color.main,
        },
    };
});
